export const isObject = (value) => {
  return (
    Boolean(value) &&
    (value.constructor === Object ||
      (!value.constructor && typeof value === 'object'))
  );
};
